import React, { useState, useEffect } from "react";
import { Input } from "components/bootstrap";
import * as ISODurationUtils from "util/ISODurationUtils";
const ISODurationInput = ({
  id,
  duration: propDuration,
  update,
  label = "Duration",
  help = "as ISO8601 Duration",
  validator = () => true,
  errorText = "invalid",
  autoFocus = false,
  required = false,
  disabled = false
}) => {
  const [duration, setDuration] = useState(propDuration);
  useEffect(() => {
    setDuration(propDuration);
  }, [propDuration]);
  const handleChange = (event) => {
    let validDuration = event.target.value;
    if (!validDuration.startsWith("P")) {
      validDuration = `P${validDuration}`;
    }
    setDuration(validDuration);
    if (ISODurationUtils.isValidDuration(validDuration, validator)) {
      update(validDuration);
    }
  };
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id,
      type: "text",
      label,
      onChange: handleChange,
      value: duration,
      help,
      addonAfter: ISODurationUtils.humanizeDuration(duration, validator, errorText),
      bsStyle: ISODurationUtils.durationStyle(duration, validator),
      autoFocus,
      required,
      disabled
    }
  );
};
export default ISODurationInput;
